<template>
  <div
    class="w-full border-1 border-solid border-secondary-300 h-23 px-4 pb-4 pt-3 text-secondary-900 rounded-lg">
    <div>
      <div class="flex items-center justify-between">
        <h3 class="text-base font-normal text-secondary-900">
          {{ title }}
        </h3>
        <BaseToggle
          :model-value="modelValue"
          :no-border="true"
          :disabled="disabled"
          @update:model-value="$emit('update:modelValue', $event)"/>
      </div>
      <span class="text-sm font-normal text-secondary-800">
        {{ description }}
      </span>
    </div>
    <Divider v-if="showContent" class="my-3" />
    <div v-if="showContent">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import BaseToggle from './BaseToggle.vue';
import Divider from 'primevue/divider';

defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  modelValue: {
    type: Boolean,
    required: true,
  },
  showContent: {
    type: Boolean,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['update:modelValue']);
</script>
